import { axios } from "../request/pcAxios"
 
class Create {
  // 上传base64图片
  static getBase64Pic (data) {
    return axios.post('/common/public/file/v2/uploadEvidenceToCos', { data })
  }
  // 上传base64到服务器
  static uploadImgByBase64 (data) {
    return axios.post('/common/public/file/uploadImgByBase64', {
      data,
      bucketName: 'nft'
    })
  }
  // 删除草稿
  static deleteArtDraftById (draftId) {
    return axios.get('/nft/public/art/draft/deleteArtDraftById/' + draftId)
  }
  // 获取当前时间
  static getNowTime () {
    return axios.get('/common/public/date/getCurrentDate')
  }
  // 上传视频为gif
  static uploadVideoToGIF (data) {
    return axios.post('/common/public/file/uploadVideoFileToCos', data, false, {
      bucketName: 'nft'
    })
  }
  // 上传任意格式文件
  static uploadFileToCos (data) {
    return axios.post('/common/public/file/v1/uploadFileToCos', data, false, {
      bucketName: 'nft'
    })
  }
  // 获取创建费单价
  static getMoneyConfig () {
    return axios.post('/admin/public/money/getMoneyConfig', {
      typeGroup: 50,
      type: 10
    })
  }
  // 获取ip
  static getRequestIp () {
    return axios.get('/common/public/ip/getRequestIp')
  }
  // 创建作品
  static saveArtDraftInfo (data) {
    return axios.post('/nft/public/art/draft/saveArtDraftInfo', data)
  }
  // 创作草稿详情
  static getArtDraftDetailById (id) {
    return axios.get('/nft/public/art/draft/getArtDraftInfoById/' + id)
  }
  // 创建创建订单
  static createArtCastOrder (data) {
    return axios.post('/nft/public/art/cast/createArtCastOrder', data)
  }
  // 钱包支付
  static payByWallet (data) {
    return axios.post('/order/public/pay/pay/v1', data)
  }
  // 创建源母板
  static createArtCast (data) {
    return axios.post('/nft/public/art/cast/createArtCast', data)
  }
}

export default Create